import { Header } from "@/components/sections/Header";
import { Hero } from "@/components/sections/Hero";
import { StatesServed } from "@/components/sections/StatesServed";
import { WhatIsSurplus } from "@/components/sections/WhatIsSurplus";
import { HowItWorks } from "@/components/sections/HowItWorks";
import { WhyChoose } from "@/components/sections/WhyChoose";
import { About } from "@/components/sections/About";
import { FAQ } from "@/components/sections/FAQ";
import { ClaimForm } from "@/components/sections/ClaimForm";
import { Footer } from "@/components/sections/Footer";

export default function Landing() {
  return (
    <main className="bg-[#FDFBF7] min-h-screen">
      <Header />
      <Hero />
      <StatesServed />
      <WhatIsSurplus />
      <HowItWorks />
      <WhyChoose />
      <About />
      <FAQ />
      <ClaimForm />
      <Footer />
    </main>
  );
}
